import React from 'react'
import Button from '../elements/Button'
import NoticesHOC from '../modules/NoticesHOC'
import { withRouter } from 'react-router-dom'

const NoticeUpgradeNbn = (props) => {
    const handleClick = event => {
        event.preventDefault()
        props.hideNotice()
        props.history.push('/upgrade-nbn')
    }

    return (
        <div className='row text-center'>
            <div className='col-12 col-lg-8 offset-lg-2'>
                <h2>Upgrade to nbn&trade; now. Enjoy 6 months of SAVING.</h2>
                <p className='lh'>Good news. You can now switch to Exetel nbn™ on a 12-month plan at your address and <span className='bold'>PAY LESS FOR 6 MONTHS</span>.</p>
                <p className='lh'>This means you can immediately upgrade to nbn™ (even if you’re still in contract) and pay no termination, transfer or activation fee.</p>
                <p className='lh'>Order now and we’ll also include a <span className='bold'>FREE nbn™ WiFi modem</span>.</p>
                <p className='mb-5 lh'>You can upgrade in My Exetel by clicking the link below, or call <a href='tel: 133938'><span className='bold'>13 39 38</span></a>.</p>
                <Button title='Upgrade now' action={handleClick} />
            </div>
        </div>
    )
}

export default withRouter(NoticesHOC(NoticeUpgradeNbn))



// WEBPACK FOOTER //
// ./resources/js/components/NoticeUpgradeNbn.js